'use strict';
module.exports = require('./AutoComplete.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/autocomplete/index.js
// module id = 25
// module chunks = 1